import { adminTitleFor } from "../page-base/admin-nav/items";

/** Nome da tela para os logs ("Abriu Carteira de perfis"). */
const TELAS_FORA_DO_MENU: [string, string][] = [
  ["/logs-de-acesso", "Logs de acesso"],
  ["/uso-da-equipe", "Uso da equipe"],
  ["/home", "Início do cliente"],
  ["/profiles-tracking", "Perfis do cliente"],
  ["/reviews", "Avaliações"],
  ["/posts", "Postagens"],
  ["/select-profile", "Escolha de perfil"],
  ["/dashboard", "Relatório do perfil"],
  ["/relatorio-winback", "Relatório winback"],
  ["/relatorio", "Relatório completo"],
  ["/reports/keywords", "Relatório de palavras"],
  ["/reports/performance", "Relatório de desempenho"],
  ["/change-password", "Trocar senha"],
  ["/payment", "Pagamento"],
];

export const nomeDaTela = (pathname: string): string => {
  // /admin é prefixo de tudo no adminTitleFor; telas fora do menu vêm primeiro.
  const fora = TELAS_FORA_DO_MENU.find(([prefixo]) => pathname === prefixo || pathname.startsWith(`${prefixo}/`));
  if (fora) return fora[1];
  return adminTitleFor(pathname) || pathname;
};

/** Perfil aberto, quando a rota carrega um (/dashboard/:id, /relatorio/:id ...). */
export const perfilDaRota = (pathname: string): string | null => {
  const m = pathname.match(/^\/(?:dashboard|relatorio|relatorio-winback|reports\/keywords)\/([^/]+)/);
  return m ? decodeURIComponent(m[1]) : null;
};
